import { render, staticRenderFns } from "./PaymentDeletion.vue?vue&type=template&id=4addef1c&"
import script from "./PaymentDeletion.vue?vue&type=script&lang=js&"
export * from "./PaymentDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports